import { truthyOnly } from "~/lib/utils";
import { ProductListFilter, SalesFilter, SalesStatusFilter } from "../../models";

// Sales Mobile filters
export function parseSaleStatusFilter(params: any): SalesStatusFilter {
  return {
    q: params.q,
    status: params.status,
  };
}

export function saleStatusFilterParams(filter: SalesStatusFilter): any {
  const qs: any = {};

  if (filter) {
    if (filter.q) {
      qs.q = filter.q;
    }

    if (filter.status) {
      qs.status = filter.status;
    }
  }

  return qs;
}

// Sales filters
export function parseSaleFilter(params: any): SalesFilter {
  return {
    q: params.q,
    locationId: params.locationId,
    departmentId: params.departmentId,
    status: params.status,
    startDt: params.startDt,
    endDt: params.endDt,
  };
}

export function saleFilterParams(filter: SalesFilter): any {
  const qs: any = {};

  if (filter) {
    if (filter.q) {
      qs.q = filter.q;
    }

    if (filter.status) {
      qs.status = filter.status;
    }

    if (filter.locationId) {
      qs.locationId = filter.locationId;
    }

    if (filter.departmentId) {
      qs.departmentId = filter.departmentId;
    }

    if (filter.departmentId) {
      qs.departmentId = filter.departmentId;
    }

    if (filter.startDt) {
      qs.startDt = filter.startDt;
    }

    if (filter.endDt) {
      qs.endDt = filter.endDt;
    }
  }

  return qs;
}

// Products filters
export const getProductFilter = (params: ProductListFilter): ProductListFilter => ({
  locationId: params.locationId,
});

export const getProductParams = (filter: ProductListFilter): ProductListFilter => truthyOnly(filter)